<template>
  <div class="dataForm" style="min-width:1000px;" v-if="detail">
    <div class="form-title mb-10 mt-10">
      <span class="label green" >业</span>
      <span class="left">业务基本信息</span>
    </div>
    <el-descriptions >
      <el-descriptions-item label="编号：">{{detail.business.no}}</el-descriptions-item>
      <el-descriptions-item label="公司名称：">{{detail.business.customerCompany}}</el-descriptions-item>
       <!-- <el-descriptions-item label="所属公司：">{{detail.business.ticketCompany}}</el-descriptions-item> -->
      <el-descriptions-item label="名称：">{{detail.business.name}}</el-descriptions-item>
      <el-descriptions-item label="品牌：">{{detail.business.brand}}</el-descriptions-item>
      <el-descriptions-item label="数量：">{{detail.business.amount}}</el-descriptions-item>
      <el-descriptions-item label="单位：">{{detail.business.unit}}</el-descriptions-item>
      <el-descriptions-item label="型号：">{{detail.business.model}}</el-descriptions-item>
      <el-descriptions-item label="序列号：">{{detail.business.serial}}</el-descriptions-item>
      <!-- <el-descriptions-item label="业务员：">{{detail.business.salesMan}}</el-descriptions-item> -->
      <!-- <el-descriptions-item label="收款人：">{{detail.customerCompanyContact.name}}</el-descriptions-item> -->
    </el-descriptions>
    <div v-if="detail.business.orderTaxRate">
      <div class="form-title mb-10">
        <span class="label blue" >订</span>
        <span class="left">订单信息</span>
      </div>
      <OrderFeeDesc :detail="detail.business" >
        <template v-slot:after>
          <el-descriptions-item label="开票状态：">{{detail.business.invoiceStatus}}</el-descriptions-item>
          <el-descriptions-item label="收款状态：">{{detail.business.receivedStatus}}</el-descriptions-item>
        </template>
      </OrderFeeDesc>
    </div>
    <div class="form-title mb-10 mt-30">
      <span class="label yellow" >审</span>
      <span class="left">审批信息</span>
    </div>
     <AccountPreview :account="detail.account" v-if="detail.account">
      <template v-slot:content>
        <el-descriptions-item label="费用：">{{$currency(detail.fee)}}</el-descriptions-item>
        <!-- <el-descriptions-item label="费用类型 ：">{{detail.feeType}}</el-descriptions-item> -->
        <el-descriptions-item label="申请时间：">{{detail.createTime}}</el-descriptions-item>
         <el-descriptions-item label="申请次数：">{{detail.times}}</el-descriptions-item>
      </template>
    </AccountPreview>
    <div class="form-title mb-10 mt-30">
      <span class="label green" >其</span>
      <span class="left">其他市场费信息</span>
    </div>
    <el-table
      :data="detail.history || []"
      border
      fit
      row-key="id"
      class="fullWidth"
      :header-cell-style="{ background: '#ddd', color: 'rgba(0,0,0,0.9)' }"
    >
      <el-table-column :prop="column.fieldKey" :label="column.fieldName" v-for="(column, index) in MarketFeeFieldData" :key="index" min-width="120">
        <template #default="{ row }" v-if="column.fieldKey === 'fee'">
          {{$currency(row.fee)}}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs, ref, onMounted, nextTick, unref } from 'vue'
import { ArrayRowsItem } from '@/model/Index'
import { marketFeeList } from '@/apis/Business'
import { ElMessage, ElForm } from 'element-plus'
import { createMarketFee, updateMarketFee } from '@/apis/BusinessMarketFee'
import OrderFeeDesc from '@/views/order/OrderFeeDesc.vue'
import AccountPreview from '@/views/business/outsourceCompany/AccountPreview/Index.vue'
import { MarketFeeFieldData } from '@/views/business/businessList/businessMarketFee/FieldTable'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  components: {
    OrderFeeDesc,
    AccountPreview
  },
  props: {
    id: { type: Number, required: false, default: 0 },
    api: { type: String, required: true },
    detail: { type: Object, required: true, default: () => null }

  },
  emits: ['update:visibel', 'submit'],

  setup(props, context) {
    const { t } = useI18n()

    const dataForm = ref(ElForm)

    const dataMap = reactive({
      detail: props.detail,
      submitLoading: false,
      MarketFeeFieldData,
      ruleForm: {
        fee: '',
        taxRate: '',
        customerCompanyId: '',
        customerNo: '',
        mark: '',
        details: []
      },
      rules: {
        titleId: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        taxRate: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        customerCompanyId: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        details: []
      },
      titleOption: [],
      companyOption: [],
      dialogVisible: false,
      taxRateList: [],
      excludeIds: [],

      handleSubmit() {
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            try {
              const tempData = dataMap.ruleForm
              const formSate = !props.id ? 'add' : 'edit'
              if (formSate === 'add') {
                await createMarketFee(props.api, tempData)
              } else {
                await updateMarketFee(props.id, tempData)
              }
              dataMap.submitLoading = false
              context.emit('update:visibel')
              context.emit('submit')
              ElMessage({
                message: !props.id ? '创建成功' : '编辑成功',
                type: 'success',
                duration: 2000
              })
            } catch (err:any) {
              console.log(err, 'err')
              dataMap.submitLoading = false
              if (err && err.errors) {
                err.errors.forEach((item: any) => {
                  const field = dataMap.rules[item.field][0]
                  if (field) {
                    field.message = null
                    nextTick(() => {
                      field.message = item.defaultMessage
                    })
                  }
                })
              }
            }
          }
        })
      }
    })
    onMounted(() => {
      marketFeeList(props.detail.business.id).then(res => {
        dataMap.detail.history = res ? res.filter((item: any) => item.id !== props.detail.id) : []
      })
    })
    return { t, ...toRefs(dataMap), dataForm }
  }
})
</script>
